import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    register_page_title_text: {
      id: 'register_page_title_text',
      defaultMessage: "Register",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/routes/register/Messages.js